module.exports = __webpack_public_path__ + "static/media/AngelsOfAether_Promo10.b6b9a133.jpg";